import {
  Icon,
  IconButton,
  IconButtonProps,
  IconName,
  MenuButton
} from '../../atoms';

type Props = IconButtonProps;

export function MenuButtonThreeDots({
  isDisabled,
  children,
  onClick,
  'aria-label': ariaLabel,
  ...rest
}: Props): JSX.Element {
  return (
    <MenuButton
      size="sm"
      as={IconButton}
      variant="tertiary"
      isDisabled={isDisabled}
      onClick={(e): void => {
        e.stopPropagation();
        onClick?.(e);
      }}
      color="palette_gray.100"
      _hover={{ bg: 'palette_gray.10' }}
      _active={{ bg: 'palette_gray.10' }}
      _disabled={{
        color: 'palette_gray.40',
        cursor: 'not-allowed',
        _hover: { bg: 'transparent' }
      }}
      icon={<Icon name={IconName.HorizontalDotsMenu} w="24px" h="24px" />}
      aria-label={ariaLabel}
      {...rest}
    >
      {children}
    </MenuButton>
  );
}
